(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.InserterDialogHandler = (function(superClass) {
    extend(InserterDialogHandler, superClass);

    function InserterDialogHandler() {
      this.data = null;
      InserterDialogHandler.__super__.constructor.call(this);
    }

    InserterDialogHandler.prototype.init = function() {
      this.layoutUrl = 'backend/admin/inserter/load-layout-dialog';
      this.classes = 'large_dialog';
      return this.createDialog();
    };

    InserterDialogHandler.prototype.afterLoadLayout = function(selector, data) {
      var ths;
      ths = this;
      this.openDialog();
      this.dialog.find('.save-btn').bind('click', (function(_this) {
        return function() {
          $(_this.parent.layoutSelector).find('#upload_form input[name="hdn_forreal"]').val(true);
          return $(_this.parent.layoutSelector).find('#btn_start_upload').click();
        };
      })(this));
      this.loadData(this.data);
      return this.dialog.find('#hdi_exception_btn').bind('click', (function(_this) {
        return function() {
          _this.dialog.find('.modal-body div').show();
          return $(_this).hide();
        };
      })(this));
    };

    InserterDialogHandler.prototype.buildJson = function(node) {
      var children, json, key, numChildren, obj, title, titleChildren, val;
      json = [];
      numChildren = 0;
      titleChildren = null;
      for (key in node) {
        val = node[key];
        obj = {};
        if (val instanceof Array || val instanceof Object) {
          children = this.buildJson(val);
          obj.children = children[1];
          title = children[0];
          if (title == null) {
            title = Object.keys(val).length;
          }
          obj.data = key + ': [ ' + title + ' ]';
        } else {
          obj.data = key + ': ' + val;
          if (++numChildren === 1) {
            titleChildren = val;
          } else {
            titleChildren = null;
          }
        }
        json.push(obj);
      }
      return [titleChildren, json];
    };

    InserterDialogHandler.prototype.buildJsTree = function(elem, json) {
      return elem.jstree({
        plugins: ['themes', 'json_data', 'ui'],
        core: {
          animation: '200'
        },
        json_data: {
          data: json,
          progressive_render: true
        },
        themes: {
          url: '/css/jstree_themes/default/style.css',
          dots: false,
          icons: false
        }
      }).bind('click.jstree', function(event, data) {
        if ($(event.target).prop('tagName') === 'A') {
          return elem.jstree('toggle_node', event.target);
        }
      });
    };

    InserterDialogHandler.prototype.loadData = function(data) {
      var i, json, key, len, message, node, ref, results;
      if (typeof data === 'string') {
        this.dialog.find('.modal-body div').toggle();
        this.dialog.find('#hdi_exception .btn').hide();
        return this.dialog.find('#hdi_exception_content').html(data);
      } else {
        if (data.exception != null) {
          this.dialog.find('.modal-body div').toggle();
          this.dialog.find('#hdi_exception_content').html('<pre>' + data.exception + '</pre>');
        }
        json = {};
        for (key in data) {
          node = data[key];
          json[key] = this.buildJson(node);
        }
        if (this.type === 'as400') {
          this.buildJsTree(this.dialog.find('#contracts_tree'), json['contracts']);
          this.buildJsTree(this.dialog.find('#hybrids_tree'), json['hybrids']);
          this.buildJsTree(this.dialog.find('#irrigation_tree'), json['irrigation']);
          this.buildJsTree(this.dialog.find('#machinery_tree'), json['machinery']);
          this.buildJsTree(this.dialog.find('#fields_tree'), json['fields']);
          this.buildJsTree(this.dialog.find('#plans_tree'), json['plans']);
        } else if (this.type === 'testplots') {
          this.buildJsTree(this.dialog.find('#fields_tree'), json['fields']);
          this.buildJsTree(this.dialog.find('#hybrids_tree'), json['hybrids']);
          this.buildJsTree(this.dialog.find('#traits_tree'), json['traits']);
        } else if (this.type === 'users') {
          this.buildJsTree(this.dialog.find('#users_failed_tree'), json['failed']);
          this.buildJsTree(this.dialog.find('#users_succeeded_tree'), json['succeeded']);
        }
        this.dialog.find('#ptime').html(data.ptime + ' ms');
        this.dialog.find('#ttime').html(data.ttime + ' ms');
        ref = data.messages;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          message = ref[i];
          results.push(this.dialog.find('#hdi_messages').append('<p>' + message + '</p>'));
        }
        return results;
      }
    };

    return InserterDialogHandler;

  })(DialogHandler);

}).call(this);
